<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
    @click:outside="handleResponse(false)"
    @keydown.esc="handleResponse(false)"
    @keydown.enter="handleResponse(true)"
  >
    <v-card class="pa-4 rounded-lg">
      <div class="d-flex flex-column align-center gap-2">
        <v-icon v-if="icon" size="48">{{ icon }}</v-icon>
        <h5 class="mb-0">{{ title }}</h5>
        <p v-html="message" class="text-center"></p>
      </div>
      <div class="d-flex align-center gap-2">
        <v-btn
          depressed
          :color="buttons.cancel?.color"
          @click="handleResponse(false)"
        >
          {{ buttons.cancel?.label }}
        </v-btn>
        <v-spacer />
        <v-btn
          depressed
          :color="buttons.confirm?.color"
          @click="handleResponse(true)"
        >
          {{ buttons.confirm?.label }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props: {
    maxWidth: {
      type: String,
      default: "400",
    },
  },
  data() {
    return {
      dialog: false,
      icon: "",
      title: "",
      message: "",
      buttons: {
        cancel: {
          label: "Cancelar",
          color: "error",
        },
        confirm: {
          label: "Confirmar",
          color: "primary",
        },
      },
      resolve: null,
      reject: null,
    };
  },
  methods: {
    confirm({ icon, title, message, buttons }) {
      this.icon = icon;
      this.title = title || "Atenção";
      this.message = message;
      this.buttons = buttons || {
        cancel: {
          label: "Cancelar",
          color: "error",
        },
        confirm: {
          label: "Confirmar",
          color: "primary",
        },
      };
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    handleResponse(confirmed) {
      this.dialog = false;
      this.resolve(confirmed);
      this.resolve = null;
      this.reject = null;
    },
  },
  beforeDestroy() {
    if (this.resolve) this.resolve(false);
  },
};
</script>
